export const BREAKOUT_CLASSNAME = "-mx-5 px-5 md:mx-0 md:px-0";

export const FLAT_SUBMENU_PT = Object.freeze({
    menuitem: {
        className:
            "max-md:[&:has(>ul)>.p-menuitem-content]:pointer-events-none max-md:[&:has(>ul)>.p-menuitem-content]:font-semibold max-md:[&:has(>ul)_.p-submenu-icon]:hidden",
    },
    submenu: {
        className:
            "max-md:static max-md:block! max-md:rounded-none max-md:py-0 max-md:pl-3 max-md:shadow-none",
    },
});
